import { atom } from 'recoil'

export const modalCopy = atom({
  key: 'TasksListModalCopyState',
  default: {
    show: false,
    idTask: undefined,
    fetchData: false
  }
})

export const modalSimulate = atom({
  key: 'TasksListModalSimulate',
  default: {
    show: false,
    idTask: undefined,
    idSimulate: undefined,
    fetchData: false,
    currentIteration: 0,
    interval: 0,
    simulateStatus: undefined,
    simulateProcessed: undefined,
    simulateDiscarded: undefined
  }
})

export const modalStatistics = atom({
  key: 'TasksListModalStatistics',
  default: {
    show: false
  }
})

export const modalDelete = atom({
  key: 'TasksListModalDelete',
  default: {
    show: false,
    idTask: undefined,
    name: ''
  }
})
